import(/* webpackMode: "eager", webpackExports: ["Faucet"] */ "/vercel/path0/components/Faucet.tsx");
